import React, { useEffect, useState } from 'react';

import { InlineSpinner } from '@/components';
import RewardCreateForm from '@/forms/reward-create-form/RewardCreateForm';
import { GameOption, fetchGameByDescriptor } from '@/hooks/useGamesSearch';
import { getGameDescriptorJson } from '@/utils';
import { RewardDetail, mapRewardToFormValues } from './mapRewardToFormValues';

type GameState = { loading: boolean; game: GameOption | null };

const RewardCloneForm = ({ reward }: { reward: RewardDetail }) => {
  const { rewardType } = reward;
  const gameJson =
    rewardType.__typename === 'FreeSpinReward'
      ? getGameDescriptorJson(rewardType.gameDescriptor)
      : undefined;

  const [{ loading, game }, setGameState] = useState<GameState>({
    loading: !!gameJson,
    game: null,
  });

  useEffect(() => {
    if (!gameJson) {
      return;
    }

    let cancelled = false;
    fetchGameByDescriptor(gameJson).then((result) => {
      if (!cancelled) {
        setGameState({ loading: false, game: result });
      }
    });

    return () => {
      cancelled = true;
    };
  }, [gameJson]);

  if (loading) {
    return <InlineSpinner />;
  }

  const initialValues = mapRewardToFormValues(reward, game);

  return (
    <RewardCreateForm
      initialValues={initialValues}
      // Only preselect the game when its provider is known as well
      initialGame={initialValues.gameProvider ? game : null}
    />
  );
};

export default RewardCloneForm;
